<template>
    <div>
        <!--搜索表单-->
        <div class="search-box">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                <el-form-item label="关键词" prop="keyWord">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.keyWord" placeholder="请输入关键词"></el-input>
                </el-form-item>
                     <el-form-item label="店铺名称:" prop="title">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.title" placeholder="请输入店铺名称"></el-input>
                    </el-form-item>
                     <el-form-item label="状态:" prop="status">
                         <el-select size="mini" filterable v-model="searchForm.status" placeholder="请选择状态">
                             <el-option v-for="item in statusList" :key="item.name" :label="item.name" :value="item.value"></el-option>
                         </el-select>
                    </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysShopManage-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                    <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                    <el-button plain size="mini" type="primary" v-display:sysShopManage-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
                    <el-dropdown>
                         <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                             批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                         </el-button>
                         <el-dropdown-menu slot="dropdown">
                             <el-dropdown-item v-display:sysShopManage-batchDelete icon="el-icon-delete" @click.native="batchDelete">批量删除</el-dropdown-item>
                             <el-dropdown-item v-display:sysShopManage-batchUpdate icon="el-icon-edit" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                             <el-dropdown-item v-display:sysShopManage-leadingIn icon="el-icon-upload" @click.native="leadingInSysShopManage">导入</el-dropdown-item>
                             <el-dropdown-item v-display:sysShopManage-export icon="el-icon-download" @click.native="exportSysShopManage">导出</el-dropdown-item>
                             <el-dropdown-item v-display:sysShopManage-exportField icon="el-icon-download" @click.native="exportSysShopManageDialog">导出选择字段</el-dropdown-item>
                             <el-dropdown-item v-display:sysShopManage-exportModule icon="el-icon-download" @click.native="exportSysShopManageModule('upsertForm')">下载模板</el-dropdown-item>
                         </el-dropdown-menu>
                     </el-dropdown>
                </el-form-item>
            </el-form>
         </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column show-overflow-tooltip prop="title" label="店铺名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创立时间" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="historyCount" label="历史档案数量" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="checkCount" label="协议数量" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="状态">
                    <template slot-scope="scope">
                        <span class="el-icon-success" v-if="scope.row.status=='0'" style="color: green;font-size: 16px">启用</span>
                        <span class="el-icon-error" v-if="scope.row.status=='1'" style="color: red;font-size: 16px">禁用</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修正日期" sortable="custom"></el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-display:sysShopManage-update @click.native="showUpdateDialog(scope.row.id)">修改</el-dropdown-item>
                            <el-dropdown-item v-display:sysShopManage-look @click.native="toLook($event,scope.row.id)">查看</el-dropdown-item>
                            <el-dropdown-item v-display:sysShopManage-delete @click.native="deleteData(scope.row.id)">删除</el-dropdown-item>
                            <el-dropdown-item v-display:sysShopManage-delete v-if="scope.row.status=='0'" @click.native="updateStatus(scope.row.id,1)">禁用</el-dropdown-item>
                            <el-dropdown-item v-display:sysShopManage-delete v-if="scope.row.status=='1'" @click.native="updateStatus(scope.row.id,0)">启用</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="600px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                  <el-form-item label="店铺名称" prop="title">
                     <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.title" placeholder="请输入店铺名称" auto-complete="off"></el-input>
                 </el-form-item>
                  <el-form-item label="状态" prop="status">
                      <el-radio-group v-model="upsertForm.status"  size="mini">
                          <el-radio-button label="0">启用</el-radio-button>
                          <el-radio-button label="1">禁用</el-radio-button>
                      </el-radio-group>
                 </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysShopManage-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysShopManage-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="600px" :visible.sync="lookVisible">
            <div>
                <el-form class="upsertForm" :inline="true" label-width="100px">
                    <el-form-item label="店铺名称" prop="title">
                        <el-input size="mini" v-model="upsertForm.title" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-input size="mini" v-model="statusMap[upsertForm.status]" readonly auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <!--批量修改-->
        <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="900px" :visible.sync="batchDialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                         <el-form-item label="店铺名称" prop="title">
                            <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.title" placeholder="请输入店铺名称" auto-complete="off"></el-input>
                        </el-form-item>
                         <el-form-item label="状态；0" prop="status">
                            <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.status" placeholder="请输入状态；0" auto-complete="off"></el-input>
                        </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
            <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                <el-button size="mini">导入总数</el-button>
            </el-badge>
            <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入成功</el-button>
            </el-badge>
            <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入失败</el-button>
            </el-badge>
            <!--表格-->
            <el-table border size="mini" v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                <el-table-column show-overflow-tooltip prop="title" label="店铺名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" sortable="custom"></el-table-column>
            </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                   style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                   :action="uploadUrl"
                   :headers="headers"
                   multiple
                   :show-file-list="false"
                   :on-success="handleSysShopManageSuccess"
                   :before-upload="beforeSysShopManageUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportSysShopManageModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
        <!--选择字段导出-->
        <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
           <div style="height: 400px;overflow-y: auto;width: 100%" >
               <!--表格-->
               <el-table border size="mini"  :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                   <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                   <el-table-column prop="key" label="英文字段名" ></el-table-column>
                   <el-table-column prop="name" label="中文字段名" ></el-table-column>
                   <el-table-column prop="newName" label="重命名字段" >
                       <template slot-scope="scope">
                           <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                       </template>
                   </el-table-column>
               </el-table>
           </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysShopManageByField">确认导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysShopManage",
        components: { noData },
        data() {
            return {
                searchForm:{
                    title: '',
                    status: '',
                    createTime: '',
                    updateTime: '',
                    keyWord:'',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        keyWordField:'title',
                        like:'title',
                    }
                },
                tableData: [],
                upsertForm:{
                        id:'',
                        title:'',
                        status:'',
                        createTime:'',
                        updateTime:''
                },
                searchRules: {
                      title: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      status: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      createTime: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      updateTime: [
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                },
                rules: {
                      title: [
                              { required: true, message: '请输入店铺名称', trigger: 'blur' },
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      status: [
                              { required: true, message: '请选择状态', trigger: 'blur' },
                          ],
                      createTime: [
                              { required: true, message: '请输入创建时间', trigger: 'blur' },
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                      updateTime: [
                              { required: true, message: '请输入更新时间', trigger: 'blur' },
                              {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                          ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysShopManage/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                batchDialog:{
                    dialogFormVisible:false,
                    title:'批量修改'
                },
                statusMap:["启用","禁用"],
                statusList:[
                    {
                        "name":"全部",
                        "value":""
                    },
                    {
                        "name":"启用",
                        "value":"0"
                    },
                    {
                        "name":"禁用",
                        "value":"1"
                    },
                ]
            }
        },
        created(){
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysShopManage/update/findSysShopManageById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysShopManage/${this.dialog.title==='增加'?'saveSysShopManage':'update/updateSysShopManage'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })
                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysShopManage/deleteSysShopManage/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysShopManage/findSysShopManagesByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysShopManage/look/lookSysShopManageById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInSysShopManage() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysShopManage() {
                axios({
                    url: `${home}/sysShopManage/exportSysShopManage`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "店铺管理列表导出.xls");
                });
            },
            exportSysShopManageModule() {
                axios({
                    url: `${home}/sysShopManage/exportSysShopManageModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "店铺管理导入模板.xls");
                });

            },
            handleSysShopManageSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysShopManageUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysShopManage/batchDeleteSysShopManage`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysShopManageDialog(){
                axios({
                    url: `${home}/sysShopManage/getSysShopManageTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });

            },
            exportSysShopManageByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/sysShopManage/exportSysShopManageByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "店铺管理选择字段导出.xls");
                    });
                }

            },
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/sysShopManage/batchUpdateSysShopManage`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
            updateStatus(id,status){
                axios({
                    url:`${home}/sysShopManage/update/updateSysShopManage`,
                    method:'POST',
                    data:{
                        "id":id,
                        "status":status
                    }
                }).then(res=>{
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.submit();
                }).catch(error=>{
                    //do something
                })
            }
        }

    }
</script>
